import { RouterContext } from '../../libs/gs-component-right-rail';
import { Body1 } from '@xo-union/tk-ui-typography';
import React, { useContext } from 'react';

import { Maybe, usePasswordMutation } from '../../generated/graphql';
import LinkButton from '../LinkButton';
import headerStyles from './header.scss';
import styles from './privacy.scss';
import Honeybadger from 'honeybadger-js';
import SettingToggle from './SettingToggle/SettingToggle';

interface Props {
  pin?: Maybe<string>;
  pinProtect?: Maybe<boolean>;
  isPublished?: boolean;
  onError: () => void;
}

export const Privacy: React.FC<Props> = ({ pin, pinProtect, isPublished = false, onError }) => {
  const { push } = useContext(RouterContext);
  const [updatePassword] = usePasswordMutation();

  const onChange = async (checked: boolean): Promise<void> => {
    if (checked === true) {
      push('password');
    } else {
      try {
        await updatePassword({
          variables: {
            attributes: {
              pin: null,
              pinProtect: false,
            },
          },
        });
      } catch (error) {
        Honeybadger.notify(error, {
          message: 'Error updating password',
          context: {
            error,
          },
        });
        onError();
      }
    }
  };

  const onEdit = () => push({ screen: 'password', params: { pin } });

  const passwordSubtitle = isPublished ? 'Password required for visitors.' : 'Password required after you publish.';

  return (
    <SettingToggle
      title="Password"
      subtitle={passwordSubtitle}
      checked={pinProtect || false}
      onChange={onChange}
      dataTestId="privacy_toggle"
    >
      {pinProtect && (
        <div className={styles.passwordContainer}>
          <div className={headerStyles.header}>
            <Body1>
              Site password: <span className={styles.sitePassword}>{pin}</span>
            </Body1>
            <LinkButton color="primary" onClick={onEdit} data-testid="edit-guest-password-link">
              Edit password
            </LinkButton>
          </div>
        </div>
      )}
    </SettingToggle>
  );
};
